module.exports = __webpack_public_path__ + "img/60020.692f9c79.png";